<template>
    <div><!-- 試作準備 -->
        <CCard>
            <CCardBody>                
                 <div class="d-flex justify-content-end mb-2">                    
                    <router-link class="btn btn-sm btn-dark ml-2" @click.native="goBackEvent" to="">{{$t('Buttons.GoBack')}}</router-link> <br>                    
                </div>
                <div class="info">
                    <div class="row">
                        <div class="col-md-2">{{ i18n("TrialProduction.Factory") }}</div>
                        <div class="col-md-10">{{trialRow.factoryName}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{ i18n("TrialProduction.Machine") }}</div>
                        <div class="col-md-10">{{trialRow.roeModel}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{ i18n("TrialProduction.Phase") }}</div>
                        <div class="col-md-10">
                            <span style="display:inline-block;min-width:300px;">{{trialRow.developPhase}}</span>
                            <button v-if="isShowBatchFinish" class="btn btn-sm btn-success mr-2" @click="doBatchFinishEvent()">{{i18n('TrialProduction.BatchFinish')}}</button>
                            <button v-if="isShowBatchSkip" class="btn btn-sm btn-success mr-2" @click="doBatchSkipEvent()">{{i18n('TrialProduction.BatchSkip')}}</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{ i18n("TrialProduction.ProjectName") }}</div>
                        <div class="col-md-10">{{trialRow.project}}</div>
                    </div>
                    <div class="row">
                        <div class="col-md-2">{{ i18n("TrialProduction.ProjectEstimatedTime") }}</div>
                        <div class="col-md-10">{{fixDateTime(trialRow.demandDate)}}</div>
                    </div>
                </div>

                <div style="overflow: auto;">
                    <table class="table ">
                        <thead class="thead-light">
                            <tr >
                                <th v-if="isShowBatchFinish || isShowBatchSkip" ><input type="checkbox" @change="checkChangeEvent" v-model="checkAll">{{ i18n("Text.TranslateAll") }}</th>
                                <th v-for="(txt , index) in headers" :key="index"
                                class="text-center">{{txt}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item , index) in planDtlList" :key="index">
                                <td class="text-center" v-if="isShowBatchFinish || isShowBatchSkip" ><input type="checkbox" v-model="item.chkVal"></td>
                                <td class="text-center">{{item.partnumber}}</td>
                                <td class="text-center">{{item.partname}}</td>
                                <td class="text-center">{{item.customerName}}</td>
                                <td class="text-center">{{fixDateTime(item.demandDate)}}</td>
                                <td class="text-center" v-for="(it , index) in otherItemHeaders" :key="index">
                                    <span v-if="isT0Sepcial(item,it)" class="text-primary" data-toggle="modal" data-target="#t0NewPartModal" @click="t0NewPartClickEvent(item,it)">T0</span> 
                                    <router-link v-else @click.native="editClickEvent(item,it)" :class="showItemStyle(item,it)" to="">{{showItemTxt(item,it)}}</router-link>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCardBody>
        </CCard>

        <!-- Modal T0 之 使用過機種數 資料顯示--> 
        <div class="modal fade" id="t0NewPartModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{ i18n("TrialProduction.ProductsUsingTheSameMaterialQuantity") }}
                    </div>
                    <div class="modal-body">
                        <table class="table ">
                            <thead class="thead-light">
                                <tr>
                                    <th class="">{{ i18n("TrialProduction.NewMaterial") }}</th>
                                    <th class="">{{ i18n("TrialProduction.ProductsUsingTheSameMaterialQuantity") }}</th>
                                    <th class="">{{ i18n("TrialProduction.ProductsUsingTheSameMaterial") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(it , index) in t0NewPartList" :key="index">                        
                                    <td class="">{{it.partNumber}}</td>
                                    <td class="">{{it.modelQty}}</td>
                                    <td class="">{{it.model}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-dark" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal 批次完成 / Skip 之審核說明書入 顯示--> 
        <div class="modal fade" id="batchItemMemoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        {{batchItemMemoModalTitle}} - {{ i18n("TrialProduction.AuditDescription") }}
                    </div>
                    <div class="modal-body">
                        <textarea v-model="batchItemMemoTxt" cols="110" rows="10" ></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-gray" data-dismiss="modal">{{$t('Buttons.Cancel')}}</button>
                        <button type="button" class="btn btn-dark" @click="confirmItemMemo">{{$t('Buttons.Ok')}}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {
            defaultHeaders : [
                this.i18n("TrialProduction.PartNumber"),this.i18n("TrialProduction.Parts"),this.i18n("TrialProduction.Vendor"),this.i18n("TrialProduction.ProjectEstimatedTime")
            ],
            headers :[],
            otherItemHeaders :[],
            trialRow : {
            },
            planDtlList : [],
            t0NewPartList :[],
            isOneVendor : false,
            checkAll : false,
            batchUpdateParam: {},
            batchItemMemoModalTitle: '',
            batchItemMemoTxt : ''
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.defaultHeaders = [
                this.i18n("TrialProduction.PartNumber"),this.i18n("TrialProduction.Parts"),this.i18n("TrialProduction.Vendor"),this.i18n("TrialProduction.ProjectEstimatedTime")
            ]

            const trialKeys = sessionStorage.getItem('trialKeys');
            this.getDetail(trialKeys);
        }
    },
    methods: {
        getDetail (pidSeqno){
            if(!pidSeqno) return;            
            if(pidSeqno.indexOf('\t') === -1) return;
            const self = this;
            const p = pidSeqno.split('\t');
            if(p[2]){
                this.isOneVendor = true; //特定廠商
            }
            const params = {pid : p[0] , vendor:  p[2]};
            const url = `${this.$apiUrl_Quality}/GetTrialDetail`;
            this.updateLoading(true);            
            this.axios.get(url , {params}).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功  
                    const otherItemHeaders = [];                    
                    const rtRows = response.data;
                    const itemMap = {};
                    if(rtRows && rtRows.planDtlItemList && rtRows.planDtlItemList.length > 0){                        
                        const firstRow = rtRows.planDtlItemList[0];
                        rtRows.planDtlItemList.forEach(r => {
                            const key = r.pid + '\t' + r.seqno;
                            if(!itemMap[key]){
                                itemMap[key] = {};
                            }
                            const m = itemMap[key];
                            m[r.item] = r;
                            if(r.seqno === firstRow.seqno){
                                otherItemHeaders.push(r.item);
                            }
                        });
                        this.otherItemHeaders = otherItemHeaders;
                    }
                    if(rtRows && rtRows.planDtlList && rtRows.planDtlList.length > 0){
                        rtRows.planDtlList.forEach(r => {
                             r.itemListForMap = itemMap[r.pid + '\t' + r.seqno];
                             r.chkVal = false;
                        });
                    }
                    const newHeaders = [...self.defaultHeaders, ...otherItemHeaders];
                    this.planDtlList = rtRows.planDtlList;
                    this.headers = newHeaders;
                    this.trialRow = rtRows;
                }                    
            }); 
        },
        goBackEvent (){
            //this.$router.push('trialproduction');
            sessionStorage.setItem('repotback',true) // 給 試作準備報表 返回判斷
            this.goBackFix();
        },
        deleteEvent (item){//刪除
            if(item.isDelete !== true){
                const self =this;
                this.$confirm('此操作將永久刪除該筆資料, 是否繼續?', '提示', {
                confirmButtonText: '確定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    self.doDeleteRow(item);
                });
            }
        },
        doDeleteRow (item){//呼叫刪除處理
            const url = `${this.$apiUrl_Quality}/DeleteTrialRowData`;
            this.updateLoading(true);
            const param = {pid:item.pid};
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功          
                    item.isDelete =true;
                    this.goBackFix();
                }                    
            }); 
        },
        canDeleted (){            
            if(this.isMember){
                return  false;
            }            
            if(this.isOneVendor){
                return false;
            }
            return  true;
        },
        t0NewPartClickEvent (item ,it){ //T0 - 使用過機種數 查看            
            if(item &&  item.itemListForMap && it ){
                //const r = item.itemListForMap[it];            
                const pid  = item.pid;
                const seqno = item.seqno;
                const url = `${this.$apiUrl_Quality}/GetTrialT0Data/${pid}/${seqno}`;
                this.updateLoading(true);            
                this.axios.get(url).then((response) => {
                    const {status , statusMessage} = response.data;
                    this.updateLoading(false);
                    if(status){
                        this.$alert(statusMessage,'警告',{type: 'warning'});
                    }else{                    
                        //--成功          
                        this.t0NewPartList = response.data;
                    }                    
                }); 
            }
        },
        editClickEvent (item,it){
            if(item &&  item.itemListForMap && it ){
                const r = item.itemListForMap[it];                 
                const trialItemKeys = item.pid + '\t' + item.seqno + '\t' + r.dtlGuid ;
                sessionStorage.setItem('trialItemKeys', trialItemKeys);
                this.$router.push('iteminformation');
            }
        },
        isT0Sepcial (item,it){
            if(item && item.developPhase === 'T0' && (it === '使用過機種數' || it === '使用過機種數(Products using the same material)')){
                return true;
            }
            return false;
        },
        showItemTxt  (item,it){
            //未上傳/待判定/結案
            if(item &&  item.itemListForMap && it ){
                const r = item.itemListForMap[it];
                return this.getLogStatusTxt(r.itemStatus);
            }
            return '';
        },
        showItemStyle  (item,it){
            //未上傳/待判定/結案
            const itemTxt = this.showItemTxt(item,it);
            if(itemTxt === '未上傳' || itemTxt === '退件'  || itemTxt === 'Not uploaded'  || itemTxt === 'Reject' ) {
                return 'uotUpload';
            } else if(itemTxt === '待判定' || itemTxt === 'waiting for judgement' ) {
                return 'undecided';
            } else if(itemTxt === '完成' || itemTxt === 'OK') {
                return 'hadFinish';
            }
            return '';
        },
        getLogStatusTxt (status){
            const map =this.logStatusMap;
            let v = map[status];
            if(v){
                return v;
            }
            return '';
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
        checkChangeEvent (){       
            if(this.planDtlList){               
                if(this.checkAll === true){
                    //全部勾選
                    this.planDtlList.forEach(r => {                             
                        r.chkVal = true;
                    });
                }else{
                    //全部取消
                    this.planDtlList.forEach(r => {                             
                        r.chkVal = false;
                    });
                }
            }
        },
        doBatchFinishEvent (){ // 執行批量完成
            this.doBatchFunc(1);
        },
        doBatchSkipEvent (){ // 執行批量Skip
            this.doBatchFunc(3);
        },
        doBatchFunc(itemStatus){
            //0待判定(且 pt.ITEM_FILE_ISUPLOAD=1)/1-OK(完成)/2-Reject(退件)/3-Skip/4-未上傳(且 pt.ITEM_FILE_ISUPLOAD=0 )/5-Reboot
           if (itemStatus === 1 || itemStatus === 3){
                this.batchUpdateParam = {
                    itemStatus: itemStatus
                };
                let hadCheckList = [];                
                this.planDtlList.forEach(r => {                             
                    if(r.chkVal ===true){ //有被勾選                                                
                        hadCheckList.push(r);
                    }
                });
                if(hadCheckList.length === 0 ){
                    this.$alert('請至少勾選一個項目','提示',{type: 'warning'});
                }else{                    
                    this.batchUpdateParam.hadCheckList = hadCheckList;
                    this.batchItemMemoTxt = '';
                    //add by 厚任 Email 2022/03/18 16:08
                    if (itemStatus === 1) {
                        this.batchItemMemoModalTitle = this.i18n('TrialProduction.BatchFinish');
                    }else if (itemStatus === 3) {
                        this.batchItemMemoModalTitle = this.i18n('TrialProduction.BatchSkip');
                    }
                    
                    this.jqModalShow('batchItemMemoModal');
                }
           }
        },
        confirmItemMemo (){ //確認 審核說明
            if(this.batchItemMemoTxt){
                this.jqModalHide('batchItemMemoModal');
                this.batchUpdateParam.itemMemo = this.batchItemMemoTxt;
                this.actionUpdateBatchPlanItemRows();
            }else{
                this.$alert('審核說明為必要輸入資料！','警告',{type: 'warning'});
            }
        },
        actionUpdateBatchPlanItemRows(){ //批量處理(完成/Skip動作)
            const url = `${this.$apiUrl_Quality}/UpdateBatchPlanItemRows`;
            this.updateLoading(true);     
            const paramData = {};
            paramData.itemStatus = this.batchUpdateParam.itemStatus;
            paramData.itemMemo = this.batchUpdateParam.itemMemo;
            const itemDtlGuidList = [];
            const hadCheckList = this.batchUpdateParam.hadCheckList;
            let pid = '';
            if(hadCheckList && hadCheckList.length >0){
                hadCheckList.forEach(r=>{
                    if(!pid){
                        pid = r.pid;
                    }                    
                    for(let k in r.itemListForMap){
                        itemDtlGuidList.push(r.itemListForMap[k].dtlGuid);
                    }
                })
            }
            paramData.pid = pid;
            paramData.itemDtlGuidList = itemDtlGuidList;
            this.axios.post(url,paramData).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{                    
                    //--成功,畫面重載
                    const trialKeys = sessionStorage.getItem('trialKeys');
                    if(trialKeys){
                        this.getDetail(trialKeys);
                    }
                }                    
            }); 
        },
        goBackFix(){
        //    this.$router.push('trialproduction');
            const beforePage = sessionStorage.getItem('beforePage');
            if(beforePage){
                this.$router.push('tentativepreparationreport');
                sessionStorage.removeItem('beforePage');
            }else{
                this.$router.push('trialproduction');
            }
        }
    },
    computed: {
        ...mapGetters(["lang"]),
        planStatusList (){
            return this.$t('planStatusList');
        },
        logStatusMap (){
            return this.listToMap(this.planStatusList, 'planStatusId' ,'planStatusCaption');
        },
        isShowBatchFinish(){
            return (!this.isMember) && this.isQMmanager;
        },
        isShowBatchSkip(){
            return (!this.isMember) && !this.isQMmanager;
        }
    },
	mounted() {
        const trialKeys = sessionStorage.getItem('trialKeys');
        if(trialKeys){
            this.getDetail(trialKeys);
        }else{
            this.goBackFix();
        }
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    // text-align: center;
    text-align: left;
    padding: 15px 5px;
}

.table tr:nth-child(even) {
    background-color: transparent;
}
.row {
    margin: 0 1px;
}
.col-md-6 {
    display: flex;
    align-items: center;
    border: solid 1px #d8dbe0;
    padding: 0;

    p {
        margin-bottom: 0;
        padding: .5rem 1rem;
        padding-right: 1rem;
        margin-right: 1rem;
        border-right: solid 1px #d8dbe0;
    }
}

.info {
    border: solid 1px #d8dbe0;

    .row {
        margin: 0;
        border-bottom: solid 1px #d8dbe0;
        .col-md-2, .col-md-10 {
            // margin: 5px;
            padding: 0;
            padding: 1rem;
        }
        .col-md-2 {
            font-weight: 900;
            background-color: #BDD6EE;
        }
        .col-md-10 {
            border-left: solid 1px #d8dbe0;
        }
    }
        
}

.table th {
    // background-color: #FFC300;
    background-color: #BDD6EE;
    color: #000;
}

.text-center .text-primary {
    cursor: pointer;
}

.modal-footer {
    background-color: transparent;
}
a.uotUpload{
    color: #EA0000;
}
a.undecided{
    color: #00DB00;
}
a.hadFinish{
    color: #0000E3;
}
</style>
